// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/App/Static/Icon.scss
// module id = 8278
// module chunks = 2